import { getSrcSet, largeWidth } from '../partials/image/image.utils';

export interface PageImage {
    host: string
    path: string
}

export const createImageAttributes = (pageImage:PageImage) => {
  const imageAspectRatioX = 16;
  const imageAspectRatioY = 9;
  const aspectRatio = {
    x: imageAspectRatioX,
    y: imageAspectRatioY,
  };
  const imageUrl = getSrcSet({ aspectRatioLarge: aspectRatio, aspectRatioMedium: aspectRatio, aspectRatioSmall: aspectRatio }, pageImage.host, pageImage.path).large;
  const imageHeight = `${(Number(largeWidth) * imageAspectRatioY) / imageAspectRatioX}`;
  return {
    imageUrl,
    imageHeight,
    imageWidth: largeWidth,
  };
};
